import { ProIp } from "./ApiURL";

//Cancel Membership  Api Url

export const deleteMemberShipAPI = ProIp + "cancelSubscriptionRoutes/deleteMembersCreation/";